<mat-card>
  <div class="footer-content">
    <div class="links">
      <small class="copyright" matTooltip="Version {{ version }}"> Copyright &copy; {{ year }} Alexander Schwartz </small>
      -
      <a [routerLink]="['/privacy-policy']"><small>Datenschutzerklärung</small></a> -
      <a [routerLink]="['/imprint']"><small>Impressum</small></a> -
      <a [routerLink]="['/contact']"><small>Kontakt</small></a>
    </div>

    <div class="-auto social-media-bar d-flex justify-content-md-end">
      <app-social-media-bar></app-social-media-bar>
    </div>
  </div>
</mat-card>
